import React from 'react';
import { CheckCircleIcon, AlertIcon } from '../icons/FormIcons';

const FormField = ({
  label,
  icon,
  required = false,
  error,
  hint,
  children,
  value,
  showSuccess = true,
}) => {
  const isValid = showSuccess && value && !error;

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
        {icon && <span className="text-indigo-500">{icon}</span>}
        <span>{label}</span>
        {required && <span className="text-orange-500 ml-1">*</span>}
        {isValid && (
          <CheckCircleIcon className="w-4 h-4 text-green-500 ml-auto" />
        )}
      </label>
      {children}
      {hint && !error && (
        <p className="text-xs text-gray-500 mt-1 flex items-center gap-1">
          {hint}
        </p>
      )}
      {error && (
        <p className="text-xs text-red-600 mt-1 flex items-center gap-1 animate-shake">
          <AlertIcon className="w-3 h-3" />
          {error}
        </p>
      )}
    </div>
  );
};

export default FormField;
